import styled from 'styled-components';

//helpers
import { screen } from '@/helpers/screen';

//miranda tokens
import { getToken } from '@loadsmart/miranda-tokens';

//theme
import { homeColor } from '@/theme/ai';

export const AIGrid = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: 1fr;
  gap: 34px;
  align-items: center;
  margin-top: 26px;

  ${screen.lg} {
    grid-template-columns: 1fr 0.92fr;
    gap: 52px;
  }
`;

export const CtaRow = styled.div`
  margin-top: 28px;
`;

export const Panel = styled.div`
  width: 100%;
  border: 1px solid ${homeColor.line};
  border-radius: 18px;
  background: rgba(11, 42, 36, 0.55);
  backdrop-filter: blur(4px);
  padding: 26px 30px 24px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.35);
`;

export const ClimbHeading = styled.div`
  font-family: ${getToken('font-family-default')};
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: ${homeColor.white};
  margin-bottom: 20px;
`;

export const Bars = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 16px;
  height: 132px;
`;

export const Bar = styled.span`
  flex: 1;
  border-radius: 6px 6px 0 0;
  background: linear-gradient(45.01deg, #00d7d7 23.29%, #84f11e 88.12%);
  height: 8px;
  opacity: 0.92;
  transition: height 1.1s cubic-bezier(0.4, 0, 0.2, 1);

  ${(props) => (props.$on ? `height: ${props.$height};` : '')}
`;

export const QuarterRow = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 12px;
`;

export const Quarter = styled.span`
  flex: 1;
  text-align: center;
  font-family: ${getToken('font-family-default')};
  font-size: 10px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: ${homeColor.white};
`;

export const ClimbFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-top: 16px;
  padding-top: 14px;
  border-top: 1px solid ${homeColor.line};
  font-family: ${getToken('font-family-default')};
  font-size: 13px;
  font-weight: 700;
  color: ${homeColor.muted2};
`;
